import { Locale } from '@finxone-platform/shared/enums';
import { AlertTypes } from '@finxone-platform/shared/sys-config-types';
import { ProfileErrorCodes } from '../error-codes/profile.type';
import { ProfileSuccessCodes } from '../success-codes/profile.type';
import { defaultProfileTranslations } from './en-GB/profile-translations';
import { SupportedToasterLocales } from './general.utils';

export const profileTranslations: {
  // For new locales just add them here to the extract
  [key in SupportedToasterLocales]: typeof defaultProfileTranslations;
} = {
  [Locale.en_GB]: defaultProfileTranslations,
  // Add more locales as needed
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const generateProfileAlerts = (translations: typeof defaultProfileTranslations) => ({
  [ProfileErrorCodes.FIRST_NAME_REQUIRED]: {
    name: 'First name required',
    type: AlertTypes.ERROR,
    title: translations.FIRST_NAME_REQUIRED_TITLE,
    description: translations.FIRST_NAME_REQUIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.EMAIL_VERIFIED_BOOLEAN]: {
    name: 'Email verified',
    type: AlertTypes.ERROR,
    title: translations.EMAIL_VERIFIED_BOOLEAN_TITLE,
    description: translations.EMAIL_VERIFIED_BOOLEAN_DESCRIPTION,
  },
  [ProfileErrorCodes.FIRST_NAME_IS_STRING]: {
    name: 'First name is string',
    type: AlertTypes.ERROR,
    title: translations.FIRST_NAME_IS_STRING_TITLE,
    description: translations.FIRST_NAME_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.LAST_NAME_REQUIRED]: {
    name: 'Last name required',
    type: AlertTypes.ERROR,
    title: translations.LAST_NAME_REQUIRED_TITLE,
    description: translations.LAST_NAME_REQUIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.LAST_NAME_IS_STRING]: {
    name: 'Last name is string',
    type: AlertTypes.ERROR,
    title: translations.LAST_NAME_IS_STRING_TITLE,
    description: translations.LAST_NAME_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.EMAIL_REQUIRED]: {
    name: 'Email required',
    type: AlertTypes.ERROR,
    title: translations.EMAIL_REQUIRED_TITLE,
    description: translations.EMAIL_REQUIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.EMAIL_INVALID]: {
    name: 'Invalid Email',
    type: AlertTypes.ERROR,
    title: translations.EMAIL_INVALID_TITLE,
    description: translations.EMAIL_INVALID_DESCRIPTION,
  },
  [ProfileErrorCodes.PASSWORD_REQUIRED]: {
    name: 'Password required',
    type: AlertTypes.ERROR,
    title: translations.PASSWORD_REQUIRED_TITLE,
    description: translations.PASSWORD_REQUIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.PASSWORD_IS_STRING]: {
    name: 'Password is string',
    type: AlertTypes.ERROR,
    title: translations.PASSWORD_IS_STRING_TITLE,
    description: translations.PASSWORD_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.COUNTRY_REQUIRED]: {
    name: 'Country required',
    type: AlertTypes.ERROR,
    title: translations.COUNTRY_REQUIRED_TITLE,
    description: translations.COUNTRY_REQUIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.COUNTRY_IS_STRING]: {
    name: 'Country is string',
    type: AlertTypes.ERROR,
    title: translations.COUNTRY_IS_STRING_TITLE,
    description: translations.COUNTRY_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.COUNTRY_IS_ISO31661ALPHA2]: {
    name: 'Country is ISO31661Alpha2',
    type: AlertTypes.ERROR,
    title: translations.COUNTRY_IS_ISO31661ALPHA2_TITLE,
    description: translations.COUNTRY_IS_ISO31661ALPHA2_DESCRIPTION,
  },
  [ProfileErrorCodes.ADDRESS1_IS_STRING]: {
    name: 'Address1 is string',
    type: AlertTypes.ERROR,
    title: translations.ADDRESS1_IS_STRING_TITLE,
    description: translations.ADDRESS1_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.ADDRESS2_IS_STRING]: {
    name: 'Address2 is string',
    type: AlertTypes.ERROR,
    title: translations.ADDRESS2_IS_STRING_TITLE,
    description: translations.ADDRESS2_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.ADDRESS3_IS_STRING]: {
    name: 'Address3 is string',
    type: AlertTypes.ERROR,
    title: translations.ADDRESS3_IS_STRING_TITLE,
    description: translations.ADDRESS3_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.ADDRESS4_IS_STRING]: {
    name: 'Address4 is string',
    type: AlertTypes.ERROR,
    title: translations.ADDRESS4_IS_STRING_TITLE,
    description: translations.ADDRESS4_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.FLAT_NAME_IS_STRING]: {
    name: 'Flat name is string',
    type: AlertTypes.ERROR,
    title: translations.FLAT_NAME_IS_STRING_TITLE,
    description: translations.FLAT_NAME_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.CITY_REQUIRED]: {
    name: 'City required',
    type: AlertTypes.ERROR,
    title: translations.CITY_REQUIRED_TITLE,
    description: translations.CITY_REQUIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.CITY_IS_STRING]: {
    name: 'City is string',
    type: AlertTypes.ERROR,
    title: translations.CITY_IS_STRING_TITLE,
    description: translations.CITY_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.POSTAL_CODE_REQUIRED]: {
    name: 'Postal code required',
    type: AlertTypes.ERROR,
    title: translations.POSTAL_CODE_REQUIRED_TITLE,
    description: translations.POSTAL_CODE_REQUIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.POSTAL_CODE_IS_STRING]: {
    name: 'Postal code is string',
    type: AlertTypes.ERROR,
    title: translations.POSTAL_CODE_IS_STRING_TITLE,
    description: translations.POSTAL_CODE_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.DOB_REQUIRED]: {
    name: 'Date of birth required',
    type: AlertTypes.ERROR,
    title: translations.DOB_REQUIRED_TITLE,
    description: translations.DOB_REQUIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.DOB_IS_STRING]: {
    name: 'Date of birth is string',
    type: AlertTypes.ERROR,
    title: translations.DOB_IS_STRING_TITLE,
    description: translations.DOB_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.DOB_IS_DATE_STRING]: {
    name: 'Date of birth is date string',
    type: AlertTypes.ERROR,
    title: translations.DOB_IS_DATE_STRING_TITLE,
    description: translations.DOB_IS_DATE_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.USERNAME_IS_STRING]: {
    name: 'Username is string',
    type: AlertTypes.ERROR,
    title: translations.USERNAME_IS_STRING_TITLE,
    description: translations.USERNAME_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.PROPERTY_NAME_IS_STRING]: {
    name: 'Property name is string',
    type: AlertTypes.ERROR,
    title: translations.PROPERTY_NAME_IS_STRING_TITLE,
    description: translations.PROPERTY_NAME_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.PROPERTY_NUMBER_IS_STRING]: {
    name: 'Property number is string',
    type: AlertTypes.ERROR,
    title: translations.PROPERTY_NUMBER_IS_STRING_TITLE,
    description: translations.PROPERTY_NUMBER_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.ORGANISATION_ID_IS_STRING]: {
    name: 'Organisation ID is string',
    type: AlertTypes.ERROR,
    title: translations.ORGANISATION_ID_IS_STRING_TITLE,
    description: translations.ORGANISATION_ID_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.ORGANISATION_ID_IS_UUID]: {
    name: 'Organisation ID is UUID',
    type: AlertTypes.ERROR,
    title: translations.ORGANISATION_ID_IS_UUID_TITLE,
    description: translations.ORGANISATION_ID_IS_UUID_DESCRIPTION,
  },
  [ProfileErrorCodes.ROLE_ID_IS_STRING]: {
    name: 'Role ID is string',
    type: AlertTypes.ERROR,
    title: translations.ROLE_ID_IS_STRING_TITLE,
    description: translations.ROLE_ID_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.PHONE_REQUIRED]: {
    name: 'Phone required',
    type: AlertTypes.ERROR,
    title: translations.PHONE_REQUIRED_TITLE,
    description: translations.PHONE_REQUIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.PHONE_IS_STRING]: {
    name: 'Phone is string',
    type: AlertTypes.ERROR,
    title: translations.PHONE_IS_STRING_TITLE,
    description: translations.PHONE_IS_STRING_DESCRIPTION,
  },
  [ProfileErrorCodes.PHONE_IS_VALID]: {
    name: 'Phone is valid',
    type: AlertTypes.ERROR,
    title: translations.PHONE_IS_VALID_TITLE,
    description: translations.PHONE_IS_VALID_DESCRIPTION,
  },
  [ProfileErrorCodes.PHONE_VERIFIED_BOOLEAN]: {
    name: 'Phone verified is boolean',
    type: AlertTypes.ERROR,
    title: translations.PHONE_VERIFIED_BOOLEAN_TITLE,
    description: translations.PHONE_VERIFIED_BOOLEAN_DESCRIPTION,
  },
  [ProfileErrorCodes.CURRENT_PASSWORD_REQUIRED]: {
    name: 'Current password is required',
    type: AlertTypes.ERROR,
    title: translations.CURRENT_PASSWORD_REQUIRED_TITLE,
    description: translations.CURRENT_PASSWORD_REQUIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.CURRENT_PASSWORD_NOT_MATCH]: {
    name: 'Current password not matched',
    type: AlertTypes.ERROR,
    title: translations.CURRENT_PASSWORD_NOT_MATCH_TITLE,
    description: translations.CURRENT_PASSWORD_NOT_MATCH_DESCRIPTION,
  },
  [ProfileErrorCodes.PASSWORD_MIN_LENGTH]: {
    name: 'Password minimum length',
    type: AlertTypes.ERROR,
    title: translations.PASSWORD_MIN_LENGTH_TITLE,
    description: translations.PASSWORD_MIN_LENGTH_DESCRIPTION,
  },
  [ProfileErrorCodes.PASSWORD_MAX_LENGTH]: {
    name: 'Password maximum length',
    type: AlertTypes.ERROR,
    title: translations.PASSWORD_MAX_LENGTH_TITLE,
    description: translations.PASSWORD_MAX_LENGTH_DESCRIPTION,
  },
  [ProfileErrorCodes.CONFIRM_PASSWORD_REQUIRED]: {
    name: 'Confirm password is required',
    type: AlertTypes.ERROR,
    title: translations.CONFIRM_PASSWORD_REQUIRED_TITLE,
    description: translations.CONFIRM_PASSWORD_REQUIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.CONFIRM_PASSWORD_MIN_LENGTH]: {
    name: 'Confirm password minimum length',
    type: AlertTypes.ERROR,
    title: translations.CONFIRM_PASSWORD_MIN_LENGTH_TITLE,
    description: translations.CONFIRM_PASSWORD_MIN_LENGTH_DESCRIPTION,
  },
  [ProfileErrorCodes.CONFIRM_PASSWORD_MAX_LENGTH]: {
    name: 'Confirm password maximum length',
    type: AlertTypes.ERROR,
    title: translations.CONFIRM_PASSWORD_MAX_LENGTH_TITLE,
    description: translations.CONFIRM_PASSWORD_MAX_LENGTH_DESCRIPTION,
  },
  [ProfileErrorCodes.NEW_AND_CONFIRM_PASSWORD_NOT_MATCH]: {
    name: 'New and confirm password not matched',
    type: AlertTypes.ERROR,
    title: translations.NEW_AND_CONFIRM_PASSWORD_NOT_MATCH_TITLE,
    description: translations.NEW_AND_CONFIRM_PASSWORD_NOT_MATCH_DESCRIPTION,
  },
  [ProfileErrorCodes.NEW_AND_OLD_PASSWORD_SAME]: {
    name: 'New and old password are same',
    type: AlertTypes.ERROR,
    title: translations.NEW_AND_OLD_PASSWORD_SAME_TITLE,
    description: translations.NEW_AND_OLD_PASSWORD_SAME_DESCRIPTION,
  },
  [ProfileErrorCodes.PASSWORD_RESET_LINK_EXPIRED]: {
    name: 'Password reset link expired',
    type: AlertTypes.ERROR,
    title: translations.PASSWORD_RESET_LINK_EXPIRED_TITLE,
    description: translations.PASSWORD_RESET_LINK_EXPIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.PASSWORD_INSECURE]: {
    name: 'Password insecure',
    type: AlertTypes.ERROR,
    title: translations.PASSWORD_INSECURE_TITLE,
    description: translations.PASSWORD_INSECURE_DESCRIPTION,
  },
  [ProfileErrorCodes.USER_NOT_EXIST]: {
    name: 'User not exist',
    type: AlertTypes.ERROR,
    title: translations.USER_NOT_EXIST_TITLE,
    description: translations.USER_NOT_EXIST_DESCRIPTION,
  },
  [ProfileErrorCodes.USER_PREFERENCE_NOT_EXIST]: {
    name: 'User preference not exist',
    type: AlertTypes.ERROR,
    title: translations.USER_PREFERENCE_NOT_EXIST_TITLE,
    description: translations.USER_PREFERENCE_NOT_EXIST_DESCRIPTION,
  },
  [ProfileSuccessCodes.MARKETING_PREFERENCE_UPDATED]: {
    name: 'Marketing preference updated',
    type: AlertTypes.SUCCESS,
    title: translations.MARKETING_PREFERENCE_UPDATED_TITLE,
    description: translations.MARKETING_PREFERENCE_UPDATED_DESCRIPTION,
  },
  [ProfileErrorCodes.PROFILE_UPDATE_LOCKOUT_DAYS]: {
    name: 'Profile update restricted',
    type: AlertTypes.ERROR,
    title: translations.PROFILE_UPDATE_LOCKOUT_DAYS_TITLE,
    description: translations.PROFILE_UPDATE_LOCKOUT_DAYS_DESCRIPTION,
  },
  [ProfileErrorCodes.PROFILE_OTP_VERIFICATION_REQUIRED]: {
    name: 'Email/Phone number must be verified with OTP',
    type: AlertTypes.ERROR,
    title: translations.PROFILE_OTP_VERIFICATION_REQUIRED_TITLE,
    description: translations.PROFILE_OTP_VERIFICATION_REQUIRED_DESCRIPTION,
  },
  [ProfileErrorCodes.BANK_STATEMENT_MISSING_CURRENCY]: {
    name: 'Selected currency is required for bank statement generation',
    type: AlertTypes.ERROR,
    title: translations.BANK_STATEMENT_MISSING_CURRENCY_TITLE,
    description: translations.BANK_STATEMENT_MISSING_CURRENCY_DESCRIPTION,
  },
});
